import { createClient } from '@supabase/supabase-js';
import { environment } from '../environments/environment';

if (!environment.supabaseUrl || !environment.supabaseAnonKey) {
  throw new Error('Missing Supabase frontend config. Set supabaseUrl and supabaseAnonKey in environment files.');
}

const isKarmaTestRuntime =
  typeof window !== 'undefined' &&
  typeof (window as Window & { __karma__?: unknown }).__karma__ !== 'undefined';

export const supabase = createClient(environment.supabaseUrl, environment.supabaseAnonKey, {
  auth: {
    ...(isKarmaTestRuntime
      ? {
          // Keep browser tests isolated from persistent auth state and lock contention.
          persistSession: false,
          autoRefreshToken: false,
          detectSessionInUrl: false,
          lock: async (_name, acquireTimeout, fn) => {
            void acquireTimeout;
            return await fn();
          },
        }
      : {}),
  },
});
